import _defineProperty from "/app/web/node_modules/@babel/runtime/helpers/esm/defineProperty";

var _TASK_TYPE_COMPONENTS;

import { TaskType } from 'core/modules/tasks/task.interface';
import { TaskFormContentHomologation } from 'src/components/Tasks/Form/Content/Homologation';
import { TaskFormContentRecognition } from 'src/components/Tasks/Form/Content/Recognition';
import styled from 'styled-components';
import { TaskFormContentReport } from './Content/Report';
import { jsx as _jsx } from "react/jsx-runtime";
var TASK_TYPE_COMPONENTS = (_TASK_TYPE_COMPONENTS = {}, _defineProperty(_TASK_TYPE_COMPONENTS, TaskType.Report, TaskFormContentReport), _defineProperty(_TASK_TYPE_COMPONENTS, TaskType.Homologation, TaskFormContentHomologation), _defineProperty(_TASK_TYPE_COMPONENTS, TaskType.Recognition, TaskFormContentRecognition), _TASK_TYPE_COMPONENTS);
/** Shows all the fields for the content of the given type */

export var TaskFormContent = function TaskFormContent(_ref) {
  var type = _ref.type,
      canEdit = _ref.canEdit,
      isReadonly = _ref.isReadonly;
  var Component = TASK_TYPE_COMPONENTS[type];
  return /*#__PURE__*/_jsx(Container, {
    children: /*#__PURE__*/_jsx(Component, {
      canEdit: canEdit,
      isReadonly: isReadonly
    })
  });
}; // Styles

var Container = styled.div.withConfig({
  displayName: "Content__Container",
  componentId: "sc-oqgcr1-0"
})([""]);